// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-action-template/src/index.tsx

// TODO: Check if the icon is alined properly.
// If it is not: Replace/extend defaultAlignedActionIconGroupProps to make it look right.
// https://stash.int.klarna.net/projects/UI/repos/bubble-ui/pull-requests/121/overview?commentId=2244923
import baseIcon, { defaultAlignedActionIconGroupProps } from '@bubble-ui/temp-icon-base';
var ActionIconHeartPath = 'M3.263 2.776A1.263 1.263 0 0 0 2 4.035c0 .336.131.652.37.889l3.627 3.504L9.641 4.91A1.255 1.255 0 0 0 9.63 3.14a1.267 1.267 0 0 0-1.785 0L5.996 4.988 4.154 3.143a1.26 1.26 0 0 0-.89-.367Zm2.733 8.43L.967 6.345A3.232 3.232 0 0 1 0 4.035c0-.87.34-1.686.956-2.3a3.27 3.27 0 0 1 4.613 0l.43.429.431-.432a3.272 3.272 0 0 1 4.614 0c.616.614.956 1.43.956 2.3 0 .869-.34 1.686-.956 2.3l-5.048 4.874Z';
var ActionIconHeart = baseIcon('ActionIconHeart', {
  groupProps: defaultAlignedActionIconGroupProps,
  getPath: () => ActionIconHeartPath
});
export default ActionIconHeart;
//# sourceMappingURL=index.js.map